import { render } from "./simcard.vue?vue&type=template&id=638cd112"
import script from "./simcard.vue?vue&type=script&lang=js"
export * from "./simcard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__